import { AppState } from '@redux/store'
import { AuthToken } from '@typesApp/Session'

export const KEY_AUTH_TOKEN = 'direct-billing.auth-token'

const EMPTY_TOKEN: AuthToken = {
  accessToken: '',
  sessionId: '',
  customerNumber: '',
  customerEmail: '',
}

export const hasCognitoSession = (token?: AuthToken): boolean =>
  token !== undefined && Object.keys(token).length > 0 && Boolean(token?.accessToken)

type FetchResult = {
  error?: {
    status: number | string
  }
}

export const shouldRefreshToken = (fetchResult: FetchResult, appState: AppState): boolean => {
  const isAuthenticationError = fetchResult?.error?.status === 401
  return isAuthenticationError && isSessionValid(appState)
}

const isSessionValid = (state: AppState): boolean => {
  const sessionId = state.connector.authTokenSessionId
  if (!sessionId || !sessionId.trim().length) {
    return false
  }
  return !state.connector.sessionExpired && !state.connector.isLoggingOut
}

export const isLocalAuthTokenValid = (token: AuthToken, sessionId: string, customerNumber?: string): boolean => {
  if (!sessionId && !customerNumber) {
    return false
  }

  if (!hasCognitoSession(token)) {
    return false
  }

  if (sessionId) return token.sessionId === sessionId

  // where commerce does not provide session id - ensure customer number matches and token has sessionId value
  return Boolean(token.sessionId) && token.customerNumber === customerNumber
}

export const getLocalAuthToken = (): AuthToken => {
  const value = window.sessionStorage.getItem(KEY_AUTH_TOKEN)
  if (!value) {
    return EMPTY_TOKEN
  }

  try {
    return JSON.parse(value ?? '{}')
  } catch (e) {
    console.warn(e)
    return EMPTY_TOKEN
  }
}

export const setLocalAuthToken = (token: AuthToken) => {
  const { claimRecordId, customerEmail, ...rest } = token
  window.sessionStorage.setItem(KEY_AUTH_TOKEN, JSON.stringify(rest))
}

export const clearLocalAuthToken = () => {
  window.sessionStorage.removeItem(KEY_AUTH_TOKEN)
}
